'use client';

export const SESSION_EXPIRED_EVENT_NAME = 'sus:session-expired';

let hasDispatchedSessionExpiredEvent = false;
let expiryDeferrals = 0;
let expiryPending = false;

/** 본인 초기화 결과를 읽는 동안 화면 이동만 유예하며 서버 인증은 복구하지 않습니다. */
export function deferSessionExpiry(): () => void {
  expiryDeferrals += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    expiryDeferrals = Math.max(0, expiryDeferrals - 1);
    if (!expiryDeferrals && expiryPending) {
      expiryPending = false;
      if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT_NAME));
    }
  };
}

/** 세션 공급자와 API 오류 양쪽에서 동일한 결과 확인 유예를 적용합니다. */
export function shouldDeferSessionExpiry(): boolean {
  if (!expiryDeferrals) return false;
  expiryPending = true;
  return true;
}

/**
 * 세션 만료 이벤트를 전역으로 한 번만 브로드캐스트합니다.
 */
export function notifySessionExpired() {
  if (typeof window === 'undefined') {
    return;
  }

  if (hasDispatchedSessionExpiredEvent) {
    return;
  }

  hasDispatchedSessionExpiredEvent = true;
  window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT_NAME));
}

/**
 * 재로그인 이후 동일 탭에서 다시 세션 만료를 감지할 수 있도록 상태를 초기화합니다.
 */
export function resetSessionExpiredNotification() {
  hasDispatchedSessionExpiredEvent = false;
}
